/* OMINA 3.0 — Pop-up de recharges après ajout au panier.

   Déclenché par l'événement cartUpdate de Dawn, puis validé sur l'état RÉEL du
   panier récupéré via /cart.js : on n'affiche jamais la proposition sur une
   supposition. Les conditions reprennent celles du cahier §13.2.

   Accessibilité : dialogue modal, focus piégé, fermeture par Échap et par clic
   sur le fond, focus restitué à l'élément d'origine. Refuser ne bloque rien. */
(function () {
  'use strict';

  var modal = document.querySelector('[data-omina-upsell-modal]');
  if (!modal) return;

  var dialog = modal.querySelector('.omina-upsell-modal__dialog');
  var statusEl = modal.querySelector('[data-omina-upsell-status]');
  var addButton = modal.querySelector('[data-omina-upsell-add]');
  var form = modal.querySelector('.omina-upsell-modal__form');

  var limeId = Number(modal.dataset.limeId);
  var refillsId = Number(modal.dataset.refillsId);
  var kitId = Number(modal.dataset.kitId);

  var lastFocused = null;
  var isOpen = false;
  var dismissed = false; // refusé une fois : on ne réinsiste pas dans la session

  function focusables() {
    return Array.prototype.slice
      .call(dialog.querySelectorAll('button, [href], input, select, textarea'))
      .filter(function (el) { return !el.disabled && el.offsetParent !== null; });
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;

    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (isOpen || dismissed) return;
    isOpen = true;
    lastFocused = document.activeElement;
    modal.hidden = false;
    // Verrou de défilement limité à la durée du dialogue (cahier §16).
    document.body.classList.add('omina-modal-open');
    document.addEventListener('keydown', onKeydown);
    var list = focusables();
    if (list.length) list[0].focus();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    dismissed = true;
    modal.hidden = true;
    document.body.classList.remove('omina-modal-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  modal.querySelectorAll('[data-omina-upsell-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  /* Conditions évaluées sur le panier réel renvoyé par Shopify. */
  function shouldOffer(cart) {
    if (!cart || !cart.items) return false;
    var hasLime = false, hasRefills = false, hasKit = false;

    cart.items.forEach(function (item) {
      if (item.product_id === limeId) hasLime = true;
      if (item.product_id === refillsId) hasRefills = true;
      if (kitId && item.product_id === kitId) hasKit = true;
    });

    return hasLime && !hasRefills && !hasKit;
  }

  function evaluate() {
    if (dismissed || isOpen) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (shouldOffer(cart)) open(); })
      .catch(function () { /* silencieux : la proposition est facultative */ });
  }

  /* Ajout des recharges : on laisse le formulaire natif faire le travail, puis
     Shopify applique lui-même la remise et renvoie les totaux réels. */
  if (form) {
    form.addEventListener('submit', function (event) {
      if (form.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }
      form.dataset.submitting = 'true';
      if (addButton) {
        addButton.classList.add('loading');
        addButton.setAttribute('aria-busy', 'true');
        var spinner = addButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }
      if (statusEl) statusEl.textContent = 'Ajout des recharges en cours…';
      // Pas de preventDefault : la soumission native fonctionne aussi sans JS.
      dismissed = true;
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // L'ajout venant du pop-up lui-même ne doit pas le rouvrir.
      if (event && event.source === 'omina-upsell-modal') return;
      setTimeout(evaluate, 350);
    });
  }
})();
